// 引擎导入必须带版本号破缓存(2026-07-02 教训):裸相对导入 "./clight-crystal.js" 无 ?v=,
// 浏览器/CDN 会缓存旧引擎 → "裁剪是新的、建模是旧的"。这里继承本文件 asset_url 的 ?v=(每次
// 部署 checksum 变→引擎同步刷新)。注意:引擎改动必须和本文件一起重新部署(实践中本就同发)。
const ENGINE_V = (()=>{ try{ return new URL(import.meta.url).searchParams.get('v')||''; }catch(e){ return ''; } })();
const ENGINE_URL = (typeof window!=='undefined' && window.__CLIGHT_ENGINE) || ('./clight-crystal.js' + (ENGINE_V ? '?v='+ENGINE_V : ''));  // 版本跟随引擎本身(liquid 传入)
const { createCrystal } = await import(ENGINE_URL);

// 初始形状:由来源子页面的形状卡带过来的 URL ?shape= 决定。
// heart / portrait / landscape;别名 vertical→portrait、horizontal→landscape;无/非法=portrait。
const SHAPE_ALIAS = { heart:'heart', portrait:'portrait', vertical:'portrait', landscape:'landscape', horizontal:'landscape' };
function resolveInitialShape(){
  try{
    const q = new URLSearchParams(window.location.search).get('shape');
    return SHAPE_ALIAS[(q||'').trim().toLowerCase()] || 'portrait';
  }catch(e){ return 'portrait'; }
}
const START_SHAPE = resolveInitialShape();

const stageEl = document.getElementById('pdp-crystal');
const c = createCrystal(stageEl, { shape:START_SHAPE, interactive:true, autoRotate:true, bloom:true });
window.__pdp = c;
const binSrc = stageEl.getAttribute('data-crystal-bin');
const demoSrc = stageEl.getAttribute('data-crystal-src');
if (binSrc) c.setPreset(binSrc);                                   // real LEPG-baked point cloud (WYSIWYG)
else if (demoSrc) c.setImageURL(demoSrc, { removeBackground:false, materialize:true });

const PRICE = {
  heart: {
    s:   { none:45.99,  plastic:65.99,  rotating:75.99,  wood:85.99  },
    m:   { none:89.99,  plastic:119.99, rotating:129.99, wood:139.99 },
    l:   { none:129.99, plastic:159.99, rotating:169.99, wood:179.99 },
    xxxl:{ none:279.99, plastic:319.99, rotating:329.99, wood:339.99 }
  },
  portrait: {
    s:   { none:39.99,  plastic:59.99,  rotating:69.99,  wood:79.99  },
    m:   { none:85.99,  plastic:115.99, rotating:125.99, wood:135.99 },
    l:   { none:115.99, plastic:145.99, rotating:155.99, wood:165.99 },
    xxxl:{ none:249.99, plastic:289.99, rotating:299.99, wood:309.99 }
  },
  landscape: {
    s:   { none:39.99,  plastic:59.99,  rotating:69.99,  wood:79.99  },
    m:   { none:89.99,  plastic:119.99, rotating:129.99, wood:139.99 },
    l:   { none:105.99, plastic:135.99, rotating:145.99, wood:155.99 },
    xxxl:{ none:275.99, plastic:315.99, rotating:325.99, wood:335.99 }
  }
};

const VARIANT = {
  heart: { s:{none:48309676769566,plastic:48309676802334,rotating:48309676867870,wood:48309676835102},
           m:{none:48309703082270,plastic:48309703115038,rotating:48309703180574,wood:48309703147806},
           l:{none:48309709439262,plastic:48309709472030,rotating:48309709537566,wood:48309709504798},
           xxxl:{none:48309716222238,plastic:48309716255006,rotating:48309716320542,wood:48309716287774} },
  portrait:{ s:{none:48136462139678,plastic:48136462172446,rotating:48136462237982,wood:48136462205214},
           m:{none:48136482357534,plastic:48136482390302,rotating:48136482455838,wood:48136482423070},
           l:{none:48136501002526,plastic:48136501035294,rotating:48136501100830,wood:48136501068062},
           xxxl:{none:48136504410398,plastic:48136504443166,rotating:48136504508702,wood:48136504475934} },
  landscape:{ s:{none:48136410595614,plastic:48136410628382,rotating:48136410792222,wood:48136410661150},
           m:{none:48136442118430,plastic:48136442151198,rotating:48136442216734,wood:48136442183966},
           l:{none:48136451162398,plastic:48136451195166,rotating:48136451260702,wood:48136451227934},
           xxxl:{none:48136453980446,plastic:48136454013214,rotating:48136454078750,wood:48136454045982} }
};

const SIZE_INFO = {
  heart: {
    s:    'best for 1–2 people · 2.8 × 3.1 in',
    m:    'best for 1–3 people · 3.5 × 4.0 in',
    l:    'best for 1–4 people · 4.2 × 4.8 in',
    xxxl: 'best for 1–5 people · 5.1 × 6.3 in'
  },
  portrait: {
    s:    'best for 1–2 people · 2.0 × 3.1 in',
    m:    'best for 1–3 people · 2.8 × 3.9 in',
    l:    'best for 1–4 people · 3.1 × 4.7 in',
    xxxl: 'best for 1–5 people · 4.7 × 7.1 in'
  },
  landscape: {
    s:    'best for 1–2 people · 3.1 × 2.0 in',
    m:    'best for 1–3 people · 3.9 × 2.8 in',
    l:    'best for 1–4 people · 4.7 × 3.1 in',
    xxxl: 'best for 1–5 people · 7.1 × 4.7 in'
  }
};
const SIZE4_LABEL = { heart:'XLarge', portrait:'XXXL', landscape:'XXXL' };

const APLUS = {
  heart: {
    m5:'https://cdn.shopify.com/s/files/1/0796/4639/2606/files/aplus_M5_Base_Heart.jpg?v=1782931703',
    m6:'https://cdn.shopify.com/s/files/1/0796/4639/2606/files/M6_Sizes_Heart_cali_v2.png?v=1782935428',
    m7:'https://cdn.shopify.com/s/files/1/0796/4639/2606/files/aplus_M7_Gift_Heart.png?v=1782931703',
    m8:'https://cdn.shopify.com/s/files/1/0796/4639/2606/files/aplus_M8_Life_Heart.jpg?v=1782931703'
  },
  portrait: {
    m5:'https://cdn.shopify.com/s/files/1/0796/4639/2606/files/aplus_M5_Base_Portrait.jpg?v=1782931703',
    m6:'https://cdn.shopify.com/s/files/1/0796/4639/2606/files/M6_Sizes_Vertical_cali.png?v=1782935155',
    m7:'https://cdn.shopify.com/s/files/1/0796/4639/2606/files/aplus_M7_Gift_Vertical.png?v=1782931703',
    m8:'https://cdn.shopify.com/s/files/1/0796/4639/2606/files/aplus_M8_Life_Vertical.jpg?v=1782931703'
  },
  landscape: {
    m5:'https://cdn.shopify.com/s/files/1/0796/4639/2606/files/aplus_M5_Base_Landscape.jpg?v=1782931704',
    m6:'https://cdn.shopify.com/s/files/1/0796/4639/2606/files/M6_Sizes_Horizontal_cali_v2.png?v=1782935428',
    m7:'https://cdn.shopify.com/s/files/1/0796/4639/2606/files/aplus_M7_Gift_Horizontal.png?v=1782931703',
    m8:'https://cdn.shopify.com/s/files/1/0796/4639/2606/files/aplus_M8_Life_Horizontal.jpg?v=1782931703'
  }
};
function updateAplus(shape){
  const set = APLUS[shape] || APLUS.portrait;
  ['m5','m6','m7','m8'].forEach(k=>{
    const el = document.getElementById('aplus-'+k);
    if(el && set[k]) el.src = set[k];
  });
}

const money = n => '$' + n.toFixed(2);
const pressed = id => document.querySelector('#'+id+' [aria-pressed="true"]');
function curShape(){ return pressed('shape-seg').dataset.shape; }

const variantInput = document.getElementById('pdp-variant');
function syncVariant(){
  const shape = curShape();
  const size  = pressed('size-grid').dataset.size;
  const base  = pressed('base-grid').dataset.base;
  variantInput.value = VARIANT[shape][size][base];
}

function updateSizeLabels(shape){
  const info = SIZE_INFO[shape] || SIZE_INFO.portrait;
  ['s','m','l','xxxl'].forEach(size=>{
    const btn = document.querySelector('#size-grid button[data-size="'+size+'"]');
    if(!btn) return;
    const span = btn.querySelector('span');
    if(span && info[size]) span.textContent = info[size];
  });
  const b4 = document.querySelector('#size-grid button[data-size="xxxl"] b');
  if(b4) b4.textContent = SIZE4_LABEL[shape] || 'XXXL';
}
function updatePrice(){
  const shape = curShape();
  const size  = pressed('size-grid').dataset.size;
  const base  = pressed('base-grid').dataset.base;
  const row   = PRICE[shape][size];
  const total = row[base];
  const was   = Math.round(total / 0.70) - 0.01;
  const save  = Math.round((1 - total / was) * 100);
  document.querySelector('.price-now b').textContent = money(total);
  document.querySelector('.price-was').textContent   = money(was);
  document.querySelector('.chip').textContent        = 'Save ' + save + '%';
  const cartPrice = document.getElementById('cart-price'); if(cartPrice) cartPrice.textContent = money(total);
  const bnpl = document.getElementById('bnpl-amt'); if(bnpl) bnpl.textContent = money(total / 4);
  document.querySelectorAll('#base-grid button[data-base]').forEach(b=>{
    const k = b.dataset.base, em = b.querySelector('em');
    if(!em) return;
    em.textContent = (k === 'none') ? 'Included' : '+ $' + Math.round(row[k] - row.none);
  });
  syncVariant();
}

const shapeSeg = document.getElementById('shape-seg');
shapeSeg.addEventListener('click', (e)=>{
  const btn = e.target.closest('button[data-shape]');
  if(!btn) return;
  [...shapeSeg.querySelectorAll('button')].forEach(b=>b.setAttribute('aria-pressed', b===btn ? 'true':'false'));
  c.setShape(btn.dataset.shape);
  updateSizeLabels(btn.dataset.shape);
  updateAplus(btn.dataset.shape);
  updatePrice();
});

function wireSelect(id){
  const grid = document.getElementById(id);
  grid.addEventListener('click', (e)=>{
    const btn = e.target.closest('button[aria-pressed]');
    if(!btn) return;
    [...grid.querySelectorAll('button')].forEach(b=>b.setAttribute('aria-pressed', b===btn ? 'true':'false'));
    updatePrice();
  });
}
wireSelect('size-grid');
wireSelect('base-grid');

// 应用初始形状:把形状选择器高亮同步到 START_SHAPE(水晶已按 START_SHAPE 创建)。
[...shapeSeg.querySelectorAll('button')].forEach(b=>b.setAttribute('aria-pressed', b.dataset.shape===START_SHAPE ? 'true':'false'));
// 尺寸强制默认【小号】(不再一上来中号):把 size-grid 高亮同步到 s;下面 updatePrice/syncVariant 会据此重算价格与变体。
const _sizeGrid = document.getElementById('size-grid');
if(_sizeGrid){ [..._sizeGrid.querySelectorAll('button')].forEach(b=>b.setAttribute('aria-pressed', b.dataset.size==='s' ? 'true':'false')); }

updateSizeLabels(curShape());
updateAplus(curShape());
updatePrice();

const fileInput  = document.getElementById('photo-input');
const statusLine = document.getElementById('status-line');

// ── 裁剪 / 构图(新增功能):上传后先框选,确认后用【裁剪图】既做预览、又随订单提交 ──
// 弹窗 HTML + CSS 由 JS 注入(不改 clight-pdp.liquid),class 全 cpc- 前缀,避免与主题/Lemon 冲突。
const CPC_CSS = `
.cpc-ov{position:fixed;inset:0;z-index:99999;background:rgba(20,15,9,.62);-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);display:flex;align-items:center;justify-content:center;padding:20px;font-family:inherit}
.cpc-ov[hidden]{display:none}
.cpc-card{background:#fff;border-radius:18px;padding:18px;max-width:640px;width:100%;box-shadow:0 40px 90px -30px rgba(0,0,0,.55);color:#2a2118}
.cpc-head{display:flex;align-items:baseline;gap:12px;margin-bottom:12px;flex-wrap:wrap}
.cpc-head b{font-size:22px;font-weight:600}
.cpc-head span{font-size:13px;color:#8a7f70}
.cpc-stage{position:relative;margin:0 auto;user-select:none;touch-action:none;overflow:hidden;border-radius:10px;background:#eee}
.cpc-stage img{width:100%;height:100%;display:block;pointer-events:none}
.cpc-box{position:absolute;border:2px solid #fff;box-shadow:0 0 0 9999px rgba(0,0,0,.5);cursor:move;box-sizing:border-box}
.cpc-box .cpc-h{position:absolute;width:16px;height:16px;background:#fff;border:1px solid #c9a15a;border-radius:3px}
.cpc-box .cpc-nw{left:-8px;top:-8px;cursor:nwse-resize}
.cpc-box .cpc-ne{right:-8px;top:-8px;cursor:nesw-resize}
.cpc-box .cpc-sw{left:-8px;bottom:-8px;cursor:nesw-resize}
.cpc-box .cpc-se{right:-8px;bottom:-8px;cursor:nwse-resize}
.cpc-tools{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-top:14px;flex-wrap:wrap}
.cpc-keep{display:flex;align-items:center;gap:7px;font-size:13px;color:#5a5140;cursor:pointer;user-select:none}
.cpc-keep input{accent-color:#c9a15a;width:15px;height:15px;cursor:pointer}
.cpc-btns{display:flex;gap:8px;flex-wrap:wrap}
.cpc-btns button{font-size:13px;padding:9px 14px;border-radius:10px;cursor:pointer;border:1px solid #e2d8c8;background:#fff;color:#5a5140}
.cpc-btns .cpc-solid{background:#c9a15a;border-color:#c9a15a;color:#fff;font-weight:600}
.cpc-load{position:absolute;inset:0;z-index:30;display:flex;align-items:center;justify-content:center;pointer-events:none;background:rgba(10,12,16,.45);-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);border-radius:inherit;opacity:1;transition:opacity .35s}
.cpc-load[hidden]{display:none}
.cpc-load__card{min-width:min(280px,80%);max-width:88%;text-align:center;padding:18px 22px;border-radius:14px;background:rgba(15,17,22,.82);border:1px solid rgba(201,161,90,.35);box-shadow:0 18px 50px -18px rgba(0,0,0,.7)}
.cpc-load__txt{font-size:13.5px;color:#f2ead9;margin-bottom:10px;line-height:1.4}
.cpc-load__bar{height:4px;border-radius:99px;background:rgba(255,255,255,.14);overflow:hidden}
.cpc-load__bar i{display:block;height:100%;width:0%;border-radius:99px;background:linear-gradient(90deg,#c9a15a,#e8cf9a);transition:width .3s}
.cpc-load.ind .cpc-load__bar i{width:38%!important;animation:cpcSlide 1.15s ease-in-out infinite}
@keyframes cpcSlide{0%{transform:translateX(-110%)}100%{transform:translateX(290%)}}
.cpc-load__sub{font-size:11px;color:#9a917f;margin-top:9px;line-height:1.45}
`;
const CPC_HTML = `
<div class="cpc-card">
  <div class="cpc-head"><b>Crop &amp; compose</b><span>Frame the part to turn into your crystal — we cut out &amp; model the cropped area.</span></div>
  <div class="cpc-stage" id="cpc-stage"><img id="cpc-img" alt=""><div class="cpc-box" id="cpc-box"><i class="cpc-h cpc-nw"></i><i class="cpc-h cpc-ne"></i><i class="cpc-h cpc-sw"></i><i class="cpc-h cpc-se"></i></div></div>
  <div class="cpc-tools">
    <label class="cpc-keep"><input type="checkbox" id="cpc-keepbg"> Keep background</label>
    <div class="cpc-btns">
      <button type="button" id="cpc-whole">Use full photo</button>
      <button type="button" id="cpc-cancel">Choose another</button>
      <button type="button" id="cpc-ok" class="cpc-solid">Use this crop →</button>
    </div>
  </div>
</div>`;
const cpcOv = document.createElement('div');
cpcOv.className = 'cpc-ov'; cpcOv.hidden = true; cpcOv.innerHTML = CPC_HTML;
const cpcStyle = document.createElement('style'); cpcStyle.textContent = CPC_CSS;
document.head.appendChild(cpcStyle); document.body.appendChild(cpcOv);

const clampv = (v,lo,hi)=> v<lo?lo : v>hi?hi : v;
const cpcStage = cpcOv.querySelector('#cpc-stage');
const cpcImg   = cpcOv.querySelector('#cpc-img');
const cpcBox   = cpcOv.querySelector('#cpc-box');
let cpcState = null, cpcDrag = null;
function cpcLayout(){ const b=cpcState.box; cpcBox.style.left=b.x+'px'; cpcBox.style.top=b.y+'px'; cpcBox.style.width=b.w+'px'; cpcBox.style.height=b.h+'px'; }

function cpcOpen(file){
  if(!file) return;
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = ()=>{
    const natW=img.naturalWidth, natH=img.naturalHeight;
    const maxW=Math.min(560, innerWidth-80), maxH=innerHeight*0.56;
    const s=Math.min(maxW/natW, maxH/natH, 1);
    const dispW=Math.round(natW*s), dispH=Math.round(natH*s);
    cpcImg.src=url;
    cpcStage.style.width=dispW+'px'; cpcStage.style.height=dispH+'px';
    cpcState={ file, url, natW, natH, dispW, dispH, img, box:{ x:dispW*0.1, y:dispH*0.1, w:dispW*0.8, h:dispH*0.8 } };
    cpcLayout();
    cpcOv.hidden=false;
  };
  img.onerror=()=>{ try{ URL.revokeObjectURL(url); }catch(_){} statusLine.textContent="Couldn't read that file — try another photo."; };
  img.src=url;
}
// 用完即释放:大图位图 + objectURL 不释放,手机上连开两张就顶到标签页内存上限(闪退/自动刷新)
function cpcFree(){
  if(cpcState && cpcState.url){ try{ URL.revokeObjectURL(cpcState.url); }catch(_){} }
  cpcImg.src=''; cpcState=null;
}

cpcStage.addEventListener('pointerdown', (e)=>{
  if(!cpcState) return;
  const r=cpcStage.getBoundingClientRect(), px=e.clientX-r.left, py=e.clientY-r.top, b=cpcState.box;
  const corner=(e.target.classList && e.target.classList.contains('cpc-h'))
    ? ['nw','ne','sw','se'].find(cc=>e.target.classList.contains('cpc-'+cc)) : null;
  const inside=px>=b.x && px<=b.x+b.w && py>=b.y && py<=b.y+b.h;
  if(corner) cpcDrag={ mode:'resize', corner, px, py, b:{...b} };
  else if(inside) cpcDrag={ mode:'move', px, py, b:{...b} };
  else return;
  cpcStage.setPointerCapture(e.pointerId); e.preventDefault();
});
cpcStage.addEventListener('pointermove', (e)=>{
  if(!cpcDrag || !cpcState) return;
  const r=cpcStage.getBoundingClientRect(), px=e.clientX-r.left, py=e.clientY-r.top;
  const dx=px-cpcDrag.px, dy=py-cpcDrag.py, { dispW, dispH }=cpcState, o=cpcDrag.b, b=cpcState.box, MIN=24;
  if(cpcDrag.mode==='move'){
    b.x=clampv(o.x+dx,0,dispW-o.w); b.y=clampv(o.y+dy,0,dispH-o.h); b.w=o.w; b.h=o.h;
  } else {                                                   // 自由裁剪:四角任意拉,无比例锁
    let left=o.x, top=o.y, right=o.x+o.w, bottom=o.y+o.h;
    if(cpcDrag.corner==='se'){ right=clampv(o.x+o.w+dx,o.x+MIN,dispW); bottom=clampv(o.y+o.h+dy,o.y+MIN,dispH); }
    if(cpcDrag.corner==='ne'){ right=clampv(o.x+o.w+dx,o.x+MIN,dispW); top=clampv(o.y+dy,0,o.y+o.h-MIN); }
    if(cpcDrag.corner==='sw'){ left=clampv(o.x+dx,0,o.x+o.w-MIN); bottom=clampv(o.y+o.h+dy,o.y+MIN,dispH); }
    if(cpcDrag.corner==='nw'){ left=clampv(o.x+dx,0,o.x+o.w-MIN); top=clampv(o.y+dy,0,o.y+o.h-MIN); }
    b.x=left; b.y=top; b.w=right-left; b.h=bottom-top;
  }
  cpcLayout();
});
cpcStage.addEventListener('pointerup', ()=>{ cpcDrag=null; });

function cpcSetOrderFile(file){ try{ const dt=new DataTransfer(); dt.items.add(file); fileInput.files=dt.files; }catch(e){} }

// ── 加载进度浮层(盖在水晶台上):模型首次下载显示百分比进度条,推理阶段显示流光条 ──
const cpcLoad=document.createElement('div');
cpcLoad.className='cpc-load'; cpcLoad.hidden=true;
cpcLoad.innerHTML='<div class="cpc-load__card"><div class="cpc-load__txt" id="cpc-load-txt">Working on your file…</div>'+
  '<div class="cpc-load__bar"><i id="cpc-load-fill"></i></div>'+
  '<div class="cpc-load__sub">Hang tight — this can take a little longer the first time.</div></div>';
if(getComputedStyle(stageEl).position==='static') stageEl.style.position='relative';
stageEl.appendChild(cpcLoad);
const cpcLoadTxt=cpcLoad.querySelector('#cpc-load-txt'), cpcLoadFill=cpcLoad.querySelector('#cpc-load-fill');
let cpcLoadMax=0;   // 进度只进不退(多文件并行下载的百分比会交错,倒退观感像坏了)
function cpcLoadShow(t){ cpcLoadMax=0; cpcLoad.hidden=false; cpcLoadUpdate(t); }
function cpcLoadUpdate(t){
  const m=(t||'').match(/(\d{1,3})%/);
  if(m){ const pct=Math.max(cpcLoadMax, Math.min(100,+m[1])); cpcLoadMax=pct;
    cpcLoad.classList.remove('ind'); cpcLoadFill.style.width=pct+'%';
    cpcLoadTxt.textContent=(t||'').replace(/\d{1,3}%/, pct+'%'); }
  else { cpcLoad.classList.add('ind'); cpcLoadTxt.textContent=t||'Working on your file…'; }
}
function cpcLoadHide(){ cpcLoad.hidden=true; cpcLoad.classList.remove('ind'); cpcLoadFill.style.width='0%'; }

// 成功后的"草稿预览"提示(用户定):预览只是草案,实物人工打磨会更精美;
// 手机端追加"用电脑看预览更清晰"(桌面端跑的是大一号深度模型,层次更好)
const cpcNote=document.createElement('div');
cpcNote.hidden=true;
cpcNote.style.cssText='margin-top:7px;font-size:12px;line-height:1.5;color:#b7a985';
const cpcIsMobile=/Android|iPhone|iPad|Mobi/i.test(navigator.userAgent) || (navigator.maxTouchPoints>1 && /Mac/.test(navigator.platform||''));
cpcNote.textContent='This is just a rough draft preview — your actual crystal is hand-crafted and refined by our artists, and will look far more beautiful.'
  + (cpcIsMobile ? ' Tip: open this page on a computer for an even sharper preview.' : '');
statusLine.insertAdjacentElement('afterend', cpcNote);

function cpcRun(file){
  cpcOv.hidden=true;
  const keepBg=cpcOv.querySelector('#cpc-keepbg').checked;   // 保留背景开关(默认关=抠掉背景)
  stageEl.scrollIntoView({ behavior:'smooth', block:'center' });
  cpcNote.hidden=true;
  cpcLoadShow('Working on your file…');
  c.setFile(file, { removeBackground:!keepBg, onStatus:(t)=>{ statusLine.textContent=t||''; if(t) cpcLoadUpdate(t); } })
    .then(()=>{ cpcLoadHide(); statusLine.textContent='Your photo is now inside the crystal — drag to turn it. Free proof next.'; cpcNote.hidden=false; })
    .catch(()=>{ cpcLoadHide(); statusLine.textContent="Couldn't read that file — try another photo."; });
}

cpcOv.querySelector('#cpc-ok').addEventListener('click', ()=>{
  if(!cpcState) return;
  const orig=cpcState.file;
  try{
    const sc=cpcState.natW/cpcState.dispW, b=cpcState.box;
    const sx=clampv(Math.round(b.x*sc),0,cpcState.natW-1), sy=clampv(Math.round(b.y*sc),0,cpcState.natH-1);
    const sw=Math.max(1,Math.round(b.w*sc)), sh=Math.max(1,Math.round(b.h*sc));
    // 输出封顶 2400px 长边:手机原图 12–48MP,按原始分辨率开画布会顶穿标签页内存(闪退/自动刷新)。
    // 2400px 对雕刻打样绰绰有余(主平台管线内部 ≤1024)。
    const CAP=2400, k=Math.min(1, CAP/Math.max(sw,sh));
    const ow=Math.max(1,Math.round(sw*k)), oh=Math.max(1,Math.round(sh*k));
    const oc=document.createElement('canvas'); oc.width=ow; oc.height=oh;
    oc.getContext('2d').drawImage(cpcState.img, sx, sy, sw, sh, 0, 0, ow, oh);
    const isPng=(orig.type==='image/png'), mime=isPng?'image/png':'image/jpeg';
    const base=(orig.name||'photo').replace(/\.[^.]+$/,'');
    oc.toBlob((blob)=>{
      cpcFree();
      if(blob){ const cropped=new File([blob], base+'-crop.'+(isPng?'png':'jpg'), {type:mime});
        cpcSetOrderFile(cropped); cpcRun(cropped);        // ★裁剪图随订单提交
      } else { cpcSetOrderFile(orig); cpcRun(orig); }     // toBlob 失败(如画布超限)→退回整图
    }, mime, 0.92);
  }catch(e){ cpcFree(); cpcSetOrderFile(orig); cpcRun(orig); }   // 任何异常→整图兜底,绝不卡死
});
cpcOv.querySelector('#cpc-whole').addEventListener('click', ()=>{
  if(!cpcState) return;
  const orig=cpcState.file; cpcFree();
  cpcSetOrderFile(orig); cpcRun(orig);                     // 整图(原文件已在 input,再设一次幂等)
});
cpcOv.querySelector('#cpc-cancel').addEventListener('click', ()=>{
  cpcOv.hidden=true; cpcFree(); fileInput.value=''; statusLine.textContent='Cancelled — pick another photo.';
});

fileInput.addEventListener('change', ()=>{        // 选图→先开裁剪弹窗(程序化设 .files 不触发 change,无重入)
  const file = fileInput.files && fileInput.files[0];
  if(!file) return;
  cpcOpen(file);
});

const scrollBtn = document.getElementById('scroll-to-create');
if (scrollBtn) scrollBtn.addEventListener('click', (e)=>{
  e.preventDefault();
  document.getElementById('photo-block').scrollIntoView({ behavior:'smooth', block:'center' });
});
